/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */
import { Box, Button, Checkbox, Grid, Typography } from '@mui/material';
import { GridLegacy } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ThumbDown, ThumbUp } from '@mui/icons-material';
import React from 'react';
import { observer } from 'mobx-react';
import { EntryContentViewModel } from '../EntryContentViewModel';
import { ENTRY_REVIEW_STATE } from '../../../../../../../types/course/Entry';
import { useViewModel } from '../../../../../../../hooks/useViewModel';
import EntryContentViewStyles from '../EntryContentViewStyles';

interface Props {
	entryState: ENTRY_REVIEW_STATE;
	entryId: string;
}

export const EntryContentButtonBoxView = observer((props: Props) => {
	const viewModel: EntryContentViewModel = useViewModel(EntryContentViewModel);
	const { entryId, entryState } = props;
	const { classes } = EntryContentViewStyles();
	return (
		<>
			{viewModel.isPublishingView() ? (
				<form
					onSubmit={(e) => {
						e.preventDefault();
						viewModel.requestPublication(entryId);
					}}>
					<Box>
						<Checkbox onChange={() => viewModel.toggleIsValidData()} value={viewModel.isValidData()} />
						<label>
							<FormattedMessage id={'entries.valid_data'} />
						</label>
					</Box>
					<Button variant={'contained'} color={'secondary'} disabled={!viewModel.isValidData()} type={'submit'}>
						<Typography>
							<FormattedMessage id={'entries.request_publication'} />
						</Typography>
					</Button>
				</form>
			) : (
				<Box className={classes.requestContainer}>
					{entryState !== ENTRY_REVIEW_STATE.APPROVED && (
						<GridLegacy container>
							{entryState === ENTRY_REVIEW_STATE.PENDING && (
								<GridLegacy item xs={6}>
									<Button
										fullWidth={true}
										onClick={() => {
											viewModel.updateReviewState(entryId, ENTRY_REVIEW_STATE.REJECTED, entryState);
										}}
										className={classes.rejectButton}>
										<Box className={classes.thumbBox}>
											<ThumbDown />
										</Box>
										<Typography>
											<FormattedMessage id={'entries.reject'} />
										</Typography>
									</Button>
								</GridLegacy>
							)}
							<GridLegacy item xs={6}>
								<Button
									fullWidth={true}
									onClick={() => {
										viewModel.updateReviewState(entryId, ENTRY_REVIEW_STATE.APPROVED, entryState);
									}}
									className={classes.approveButton}>
									<Box className={classes.thumbBox}>
										<ThumbUp />
									</Box>
									<Typography>
										<FormattedMessage id={'entries.approve'} />
									</Typography>
								</Button>
							</GridLegacy>
						</GridLegacy>
					)}
				</Box>
			)}
		</>
	);
});
